import React from 'react';
import { Box } from '@common-fe/common-fe';

import { BankingBalanceDetailItem } from '@/modules/employer/components/BankingBalance/types';

import BankingBalancePlanDetails from '../BankingBalancePlanDetails/BankingBalancePlanDetails';

import BankingBalanceOrgDetailsCard from './BankingBalanceOrgDetailsCard';
import BankingBalanceOrgDetailsHeader from './BankingBalanceOrgDetailsHeader';

interface Props {
  orgId: string;
  formattedData?: BankingBalanceDetailItem;
  logoUrl?: string;
  formattedLastDate: string;
  isPlansVisible: boolean;
  isLoading?: boolean;
  onSeeIncomingPayments?: () => void;
}

export const BankingBalanceOrganizationDetails: React.FC<Props> = ({
  orgId,
  formattedData,
  logoUrl,
  formattedLastDate,
  isPlansVisible,
  isLoading,
  onSeeIncomingPayments,
}) => {
  return (
    <Box>
      <BankingBalanceOrgDetailsHeader
        orgName={formattedData?.orgName}
        logoUrl={logoUrl}
        isLocked={formattedData?.isLocked}
        lastUpdatedAt={formattedLastDate}
        orgType={formattedData?.orgType}
      />
      <Box
        data-testid="org-details-card"
        margin={{ top: 'spacing24' }}
        pad="spacing24"
        background={{ color: 'module' }}
        round="moduleRound"
        gap="spacing24"
      >
        <BankingBalanceOrgDetailsCard
          data={formattedData}
          isLoading={isLoading}
          onSeeIncomingPayments={onSeeIncomingPayments}
        />
        {isPlansVisible && (
          <BankingBalancePlanDetails plans={formattedData?.plans} orgId={orgId} />
        )}
      </Box>
    </Box>
  );
};
